export { DMS_MODULE, PARTNER } from '../constants';
export const NAME = 'GDPR';
export const CRUMB_LABEL_LIST = 'grdMio';
